import en from './plaidStrings.en';

export default {
  en,
};
